import { defineRecipe } from '@chakra-ui/react';
import Input from './Input';

const Textarea = defineRecipe({
  base: Input.base ?? {},
  variants: { visual: { primary: Input.variants?.visual?.primary ?? {} } },
  defaultVariants: { visual: 'primary' },
});

export default Textarea;
